import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { CURRENT_PROMO } from '~/utils/promoHelper';
const PartnerBannerFirstChoice = () => {
  const $ = _c(7);
  const t = useTranslations("content.promo");
  const tCommon = useTranslations("common");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = CURRENT_PROMO();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    isPromoLive,
    termsUrl
  } = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <a href="https://www.byway.travel/first-choice" target="_blank" rel="noopener noreferrer" className="flex flex-row items-center"><img src={isPromoLive ? "/static/images/FC_Byway-Top-Banner-cropped.svg" : "/static/images/FC_Byway-Top-Banner.svg"} alt="First Choice. Flight-free travel, powered by Byway. Find out more." style={{
        height: "60px"
      }} /></a>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t || $[3] !== tCommon) {
    t2 = isPromoLive ? <p className="text-xs md:text-base">{t("banner_copy")}<a href={termsUrl} aria-label={t("aria_terms")} target="_blank" rel="noopener noreferrer" className="underline">{tCommon("learn_more")}</a>.</p> : null;
    $[2] = t;
    $[3] = tCommon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="flex flex-row items-center justify-center text-white md:justify-center p-2 text-sm text-center bg-firstchoice z-[100] md:text-base md:text-md">{t1}{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export { PartnerBannerFirstChoice };